import React, { useState } from 'react'
import Layout from "../../components/Layout";
import Link from "next/link";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import ReactWOW from "react-wow";
import "animate.css";
import { Fade } from "./../../components/Animation";
import Footer from "../../components/Footer";
import { fetchEntries } from '../../utils/contentfulBlogs';
import * as moment from 'moment';
import { meta } from "../../utils/meta";
// import Paginate from '../../components/Pagination';
import Paginate from "../../components/Pagination/paginate"
interface Props {
    posts: any[];
}
const Blog = (props: Props) => {
    const page = meta.blog;
  
    const [currentPage, setCurrentPage] = useState(1);
	const [postsPerPage] = useState(12);
console.log(currentPage, "avi")

	const indexOfLastPost = currentPage * postsPerPage;
	const indexOfFirstPost = indexOfLastPost - postsPerPage;
    console.log(indexOfFirstPost, 'indexOfFirstPost')
	const currentPosts = props.posts.slice(indexOfFirstPost, indexOfLastPost);

	const paginate = (pageNumber:number) => {
		setCurrentPage(pageNumber);
	};

	const previousPage = () => {
		if (currentPage !== 1) {
			setCurrentPage(currentPage - 1);
		}
	};

	const nextPage = () => {
		if (currentPage !== Math.ceil(props.posts.length / postsPerPage)) {
			setCurrentPage(currentPage + 1);
		}
	};
  
    return (
        <Layout title={page.title} description={page.description} keywords={page.keywords}>
            <section className="bg-white">
                <div className="grid place-items-center blog-banner">
                    <div className="p-6 container m-auto md:px-12 xl:px-24">
                        <div className="">
                            <div className="">
                                <div className="flex flex-col justify-center ">
                                    <h1 className="text-4xl xxs:text-5xl md:text-6xl font-configBold text-white">
                                        Blog
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="px-4 xl:px-20 blog-page-bg">
                <section className="py-8 md:py-20">
                    <div className="container mx-auto text-titleColor">
                        <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-x-5 gap-y-7'>
                        {/**Blog List **/}
                        {currentPosts.map((post: any, index: number) => (
                            <div className="bg-white rounded blog-page-hover-shadow shadow" key={index}>
                                <Link href={`/blog/${post.slug}`}>
                                    <a className="">
                                        <Fade triggerOnce delay={500}>
                                            <img src={post?.image?.fields?.file?.url} className="object-contain mx-auto rounded-t"
                                                 alt={post?.image?.fields?.title}
                                            />
                                        </Fade>
                                    </a>
                                </Link>
                                <Fade triggerOnce delay={500}>
                                    <div className="blog-desc-wrap py-4 px-6">
                                        <h2 className="text-2xl sm:text-3xl tracking-wide text-titleColor hover:text-primary focus:text-primary font-configMedium mb-1">
                                            <Link href={`/blog/${post.slug}`}>
                                                <a>{post?.title}</a>
                                            </Link>
                                        </h2>
                                        <div className="flex flex-row justify-start pt-0.5">
                                            <div className="flex flex-row items-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-400 relative -top-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                </svg>
                                                <span className="pl-1.5 pr-4 text-bodyColor text-sm leading-snug">{moment.default(post?.updatedAt).format('MMM Do YY')}</span>
                                            </div>
                                            <div className="flex flex-row items-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-400 relative -top-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                                <span className="pl-1.5 text-bodyColor text-sm leading-snug">{moment.default(post?.updatedAt).format('h:mm:ss a')}</span>
                                            </div>
                                        </div>
                                        <div className="pt-3 grid grid-col-1">
                                            <p className="pb-4 text-base leading-snug">
                                                {post?.shortDescription}
                                            </p>
                                            <div className="flex w-100  mb-3">
                                            <Link href={`/blog/${post.slug}`}>
                                                <a className="transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-102 hover:opacity-90 
                                              text-white border-2 border-primary bg-primary inline-flex w-auto rounded font-primaryMedium px-4 py-1.5 text-base text-center">
                                                    Read More
                                                </a>
                                            </Link>
                                            </div>
                                           

                                        </div>
                                    </div>
                                </Fade>
                            </div>
                        ))
                        }
                        {/**End Blog List **/}
                        </div>
                        <Paginate
						postsPerPage={postsPerPage}
						totalPosts={props.posts.length}
						currentPage={currentPage}
						paginate={paginate}
						previousPage={previousPage}
						nextPage={nextPage}
					/>
                    </div>
                </section>
            </div>
            <Footer />
            <ToastContainer position="bottom-center" autoClose={8000} />
        </Layout >
    );
};



export async function getStaticProps() {

    const res: any = await fetchEntries({ content_type: 'blogs' });
    const posts = await res.map((p: any) => {
        return { ...p.fields, createdAt: p.sys.createdAt, updatedAt: p.sys.updatedAt }
    });
    return {
        props: {
            posts
        },
    };
}

export default Blog;
